import { faArrowRightFromBracket, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useRef } from 'react'
import { Link, useLocation } from 'react-router-dom';

export default function SideBar() {

    const location = useLocation();

    const menuItems = [
        {
            id: "dashboard",
            label: "DASHBOARD",
            icon: "dash",
            path: "/user/dashboard",
        },
        // {
        //     id: "marketplace",
        //     label: "MARKETPLACE",
        //     icon: "home",
        //     path: "",
        // },
        // {
        //     id: "settings",
        //     label: "SETTINGS",
        //     icon: "gear",
        //     path: "",
        // }
    ];

    const [openToggle, setOpenToggle] = useState(false);

    const handleOpen = () => {
        setOpenToggle(!openToggle)
    }

    const [isToggleLogout, setToggleLogout] = useState(false);
    const chooseRef = useRef(null);
    const barRef = useRef(null);


    return (
        <>
            <div className='hidden lg:block bg-black text-white lg:w-[10%] py-5 px-3'>
                <div className='grid content-between h-full'>
                    <div className='grid gap-3'>
                        <img onClick={() => { window.location.href = '/' }} className='cursor-pointer' src='/assets/logo/GLX_NEW_WT BG_Low.png'></img>
                        <div className='mt-3'>
                            {menuItems.map((item) => {
                                const isActive = location.pathname === item.path;
                                return (
                                    <Link to={item.path} key={item.id}>
                                        <div
                                            className={`flex flex-col items-center gap-3 py-3 px-5 cursor-pointer transition-all duration-300 text-sm 
                                ${isActive ? "text-[#24FF00] font-medium" : "text-white"}`}>
                                            <img
                                                src={`/assets/icon/${isActive ? `${item.icon}.svg` : `${item.icon}white.svg`}`}
                                                alt={item.label}
                                                className="w-5 h-5"
                                            />
                                            <span>{item.label}</span>
                                        </div>
                                    </Link>
                                );
                            })}
                        </div>
                    </div>
                    <div className="relative flex flex-col items-center gap-2 mb-5  ">
                        {isToggleLogout && (
                            <div className="absolute bottom-full mb-4 left-5 " ref={chooseRef} style={{ zIndex: 20 }}>
                                <div className="text-sm 2xl:text-base text-white flex flex-col cursor-pointer bg-black capitalize 
                                font-bold duration-500 gap-1 border border-white/20 rounded-lg text-center text-nowrap px-5 py-3 hover:text-white hover:bg-white/10  transition duration-300"
                                    onClick={() => {
                                        sessionStorage.removeItem('player_token');
                                        sessionStorage.removeItem('club_token');
                                        window.location.href = '/';
                                        setToggleLogout(false);
                                    }}
                                >
                                    Logout
                                </div>
                            </div>
                        )}
                        <FontAwesomeIcon
                            icon={faArrowRightFromBracket}
                            className="cursor-pointer text-white text-2xl"
                            onClick={() => setToggleLogout(prev => !prev)}
                        />
                    </div>
                </div>
            </div>
            <div className={`block lg:hidden bg-black text-white lg:w-[10%] transition-all duration-500 ease-in-out ${openToggle ? 'max-h-[500px] py-5' : 'max-h-0 py-0 overflow-hidden'}`}>
                {menuItems.map((item) => {
                    const isActive = location.pathname === item.path;
                    return (
                        <Link to={item.path} key={item.id}>
                            <div
                                className={`flex items-center gap-5 py-3 px-5 cursor-pointer transition-all duration-300 
                                ${isActive ? "text-[#24FF00] font-medium" : "text-white"}`}>
                                <img
                                    src={`/assets/icon/${isActive ? `${item.icon}.svg` : `${item.icon}white.svg`}`}
                                    alt={item.label}
                                    className="w-5 h-5"
                                />
                                <span>{item.label}</span>
                            </div>
                        </Link>
                    );
                })}
            </div>
            {/* <div className='block px-5 pt-5'>
                <div className='flex flex-col gap-1 curser-pointer' onClick={() => { sessionStorage.removeItem('player_token'); sessionStorage.removeItem('club_token'); window.location.href = '/'; }}>
                    <div className={`duration-500 h-[2px] bg-gray-200 ${openToggle ? 'w-6 rotate-45 translate-y-1' : 'w-7'}`}>Logout</div>
                    <div className={`duration-500 h-[2px] bg-gray-200 ${openToggle ? 'w-6 -rotate-45 -translate-y-0.5' : 'w-5'}`}></div>
                </div>
            </div> */}
        </>
    )
}
